import React, { useState, useEffect } from "react"; // Tambahkan useEffect
import { Save, Edit3, X, User, LayoutGrid } from "lucide-react";
import SectionHeader from "../../Common/SectionHeader";
import AppSettings from "./AppSettings";
import AccountSettings from "./AccountSettings";
import { getDataByAll } from "../../../api/userApi"; // Import API user

const SettingsIndex = ({ isSidebarOpen }) => {
  const [activeTab, setActiveTab] = useState("app");
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  
  // State untuk Account Settings
  const [userAccount, setUserAccount] = useState(null);
  const [isFetchLoading, setIsFetchLoading] = useState(true);

  const [settings, setSettings] = useState({
    appName: "Siloam Cardiac Summit",
    companyName: "Siloam International Hospitals",
    officialWebsite: "www.siloamcardiacsummit.id",
    emailSupport: "admin@siloamcardiacsummit.id",
    contactPerson: "+62 852-8106-5557",
    address: "Gedung FK UPH Lt. 30, Jl. Boulevard Jend. Sudirman No. 15, Lippo Village, Tangerang, Banten",
    aboutUs: "Siloam International Hospitals menghadirkan Siloam Cardiac Summit sebagai wadah edukasi dan kolaborasi tenaga medis profesional.",
  });

  // Ambil data user berdasarkan email yang login
  useEffect(() => {
    const loggedInEmail = localStorage.getItem("eventManagementAUserEmail"); // Pastikan key ini ada saat login
    
    getDataByAll().then((allUsers) => {
      // Cari user yang sedang login dari mock data (default ke admin jika tidak ditemukan)
      const current = allUsers.find(u => u.email === loggedInEmail) || allUsers[0];
      setUserAccount(current);
      setIsFetchLoading(false);
    });
  }, []);

  const handleSave = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setIsEditMode(false);
      alert("Settings updated successfully!");
    }, 1000);
  };

  const SettingGroup = ({ title, icon: Icon, children }) => (
    <div className="bg-white dark:bg-white/5 rounded-2xl p-6 border border-stone-100 dark:border-white/5 shadow-sm h-full transition-all">
      <div className="flex items-center gap-3 mb-6 pb-3 border-b border-stone-50 dark:border-white/5">
        <div className="p-2 bg-stone-50 dark:bg-slate-800 rounded-lg">
          <Icon size={18} className="text-stone-600 dark:text-blue-400" />
        </div>
        <h3 className="text-sm font-semibold tracking-tight text-stone-800 dark:text-white">{title}</h3>
      </div>
      <div className="space-y-5">{children}</div>
    </div>
  );

  return (
    <div className="p-6 space-y-6 max-w-full font-sans">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <SectionHeader 
          title="Settings" 
          subtitle={activeTab === "app" ? "Manage app identity and official information" : "Manage your personal account and security"} 
        />
        
        <div className="flex items-center gap-3">
          <button
            onClick={() => setIsEditMode(!isEditMode)}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-xs font-semibold transition-all border ${
              isEditMode ? "bg-stone-100 border-stone-200 text-stone-600" : "bg-white border-stone-200 text-stone-700 shadow-sm"
            }`}
          >
            {isEditMode ? <><X size={16} /> Cancel</> : <><Edit3 size={16} /> Edit Settings</>}
          </button>
          {isEditMode && (
            <button 
              onClick={handleSave} 
              disabled={loading} 
              className="flex items-center gap-2 px-6 py-2.5 bg-[#0F172A] text-white rounded-xl text-xs font-semibold shadow-lg disabled:opacity-50 active:scale-95 transition-all"
            >
              <Save size={16} /> {loading ? "Saving..." : "Save Changes"}
            </button>
          )}
        </div>
      </div>

      <div className="flex items-center gap-1 p-1 bg-stone-100 dark:bg-white/5 rounded-2xl w-fit">
        {/* Tab Buttons */}
        <button
          onClick={() => { setActiveTab("app"); setIsEditMode(false); }}
          className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-xs font-bold transition-all ${
            activeTab === "app" ? "bg-white dark:bg-slate-800 text-slate-900 dark:text-white shadow-sm" : "text-stone-500 hover:text-stone-700"
          }`}
        >
          <LayoutGrid size={16} /> App Settings
        </button>
        <button
          onClick={() => { setActiveTab("account"); setIsEditMode(false); }}
          className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-xs font-bold transition-all ${
            activeTab === "account" ? "bg-white dark:bg-slate-800 text-slate-900 dark:text-white shadow-sm" : "text-stone-500 hover:text-stone-700"
          }`}
        >
          <User size={16} /> Account Settings
        </button>
      </div>

      <div className="transition-all duration-300">
        {activeTab === "app" ? (
          <AppSettings 
            isEditMode={isEditMode}
            settings={settings}
            setSettings={setSettings}
            SettingGroup={SettingGroup}
            isSidebarOpen={isSidebarOpen}
          />
        ) : (
          <AccountSettings 
            isEditMode={isEditMode}
            userData={userAccount} // Kirim data hasil fetch
            isLoading={isFetchLoading} // Kirim status loading
            SettingGroup={SettingGroup}
            isSidebarOpen={isSidebarOpen}
          />
        )}
      </div>
    </div>
  );
};

export default SettingsIndex;